import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-501816e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Release from Placement")
  ])
], -1))
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1))
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Batch", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Trainees", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6 mt-5"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("b", { class: "text-primary" }, "Note:"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("p", { class: "text-info" }, " Please update certification status. ")
      ])
    ])
  ])
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-3" }, "Job Release Employment List", -1))
const _hoisted_30 = { class: "card mb-5 mb-xl-10" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1))
const _hoisted_32 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_33 = { class: "collapse show" }
const _hoisted_34 = { class: "card-body border-top p-6" }
const _hoisted_35 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#release_information",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"border-top-right-radius":"6px !important","border-top-left-radius":"6px !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Release Information ")
  ])
], -1))
const _hoisted_37 = {
  class: "card p-4",
  style: {"border-top-right-radius":"0px !important","border-top-left-radius":"0px !important"}
}
const _hoisted_38 = {
  id: "release_information",
  class: "collapse show"
}
const _hoisted_39 = { class: "card-body" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Release Date")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Remarks"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    style: {"width":"100%"}
  })
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-md btn-success mt-7"
  }, " Release ")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-6 p-4" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"border-top-right-radius":"6px !important","border-top-left-radius":"6px !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Employment Information ")
  ])
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card p-4",
  style: {"border-top-right-radius":"0px !important","border-top-left-radius":"0px !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "employee_information",
    class: "collapse show"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "" }, [
            /*#__PURE__*/_createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio1",
              value: "option1",
              style: {"margin-right":"10px","margin-left":"-8px"},
              checked: "checked"
            }),
            /*#__PURE__*/_createElementVNode("label", {
              class: "form-check-label ml-2",
              for: "inlineRadio1",
              style: {"font-weight":"500","font-size":"15px !important"}
            }, "Job Release Employment")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("h5", {
          class: "my-5",
          "data-v-8a8a96d6": "",
          style: {"margin-left":"23px","color":"rgb(25, 146, 194)"}
        }, " Current Employment Status "),
        /*#__PURE__*/_createElementVNode("ul", { class: "list-group" }, [
          /*#__PURE__*/_createElementVNode("li", { class: "list-group-item d-flex" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fa-list-alt fas fs-2" }),
              /*#__PURE__*/_createTextVNode("Is Currently Employed ")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "" }, [
              /*#__PURE__*/_createElementVNode("span", {
                class: "label label-success labeldesign",
                id: "currentJobStatus"
              }, "Yes")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("li", { class: "list-group-item d-flex" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-start w-100" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fa-list-alt fas fs-2" }),
              /*#__PURE__*/_createTextVNode(" Previous Employment "),
              /*#__PURE__*/_createElementVNode("a", {
                href: "javascript:;",
                onclick: "EMPLOY_TRAINEE.gotoJobHistory()",
                "data-original-title": "",
                title: ""
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fa-paper-plane fas fs-2 ml-3" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "" }, [
              /*#__PURE__*/_createElementVNode("span", {
                class: "label labeldesignDanger",
                id: "previousJobCount"
              }, "0")
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-6 p-4" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employer_information",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"border-top-right-radius":"6px !important","border-top-left-radius":"6px !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Employer Information ")
  ])
], -1))
const _hoisted_50 = {
  class: "card p-4",
  style: {"border-top-right-radius":"0px !important","border-top-left-radius":"0px !important"}
}
const _hoisted_51 = {
  id: "employer_information",
  class: "collapse show"
}
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Company Name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    style: {"width":"100%"}
  })
], -1))
const _hoisted_55 = { class: "col-md-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Joining Date", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    style: {"width":"100%"}
  })
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Designation"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      style: {"width":"100%"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Department"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      style: {"width":"100%"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Monthly Income"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      style: {"width":"100%"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Remarks"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      style: {"width":"100%"}
    })
  ])
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-6 p-4" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Employment Information"),
  /*#__PURE__*/_createElementVNode("div", { class: "card mb-5 mb-xl-10" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card-header border-0 cursor-pointer bg-light px-4",
      role: "button",
      "data-bs-target": "#trainee_data",
      "aria-expanded": "true",
      "aria-controls": "form"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
            /*#__PURE__*/_createElementVNode("input", {
              type: "text",
              class: "form-control ps-10 w-200px mt-1 form-control-sm",
              style: {"height":"1em"},
              placeholder: "Search"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "col-md-6 mt-1 text-end",
          "data-v-54b12dc8": ""
        }, [
          /*#__PURE__*/_createElementVNode("button", {
            type: "button",
            class: "btn btn-dark fs-7 p-2 rounded-0",
            title: "Download Xlse",
            "data-v-54b12dc8": ""
          }, [
            /*#__PURE__*/_createElementVNode("i", {
              class: "fas fa-file-excel fs-5",
              "data-v-54b12dc8": ""
            }),
            /*#__PURE__*/_createTextVNode(" Excel ")
          ]),
          /*#__PURE__*/_createElementVNode("button", {
            type: "button",
            class: "btn btn-warning fs-7 p-2 rounded-0",
            title: "Download PDF",
            "data-v-54b12dc8": ""
          }, [
            /*#__PURE__*/_createElementVNode("i", {
              class: "fas fa-file-pdf fs-5",
              "data-v-54b12dc8": ""
            }),
            /*#__PURE__*/_createTextVNode(" PDF ")
          ]),
          /*#__PURE__*/_createElementVNode("button", {
            type: "button",
            class: "btn btn-primary fs-7 p-2 rounded-0",
            title: "Download CSV",
            "data-v-54b12dc8": ""
          }, [
            /*#__PURE__*/_createElementVNode("i", {
              class: "fas fa-file-csv fs-5",
              "data-v-54b12dc8": ""
            }),
            /*#__PURE__*/_createTextVNode(" CSV ")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "trainee_data",
      class: "collapse show"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "collapse show" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card-body border-top p-6" }, [
          /*#__PURE__*/_createElementVNode("div", {
            class: "current",
            "data-kt-stepper-element": "content"
          }, [
            /*#__PURE__*/_createElementVNode("table", { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }, [
              /*#__PURE__*/_createElementVNode("thead", null, [
                /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-primary" }, [
                  /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " SL "),
                  /*#__PURE__*/_createElementVNode("th", {
                    class: "w-50px text-center align-middle border border-gray-400",
                    style: {"text-align":"center"}
                  }, " Organization "),
                  /*#__PURE__*/_createElementVNode("th", { class: "w-50px text-center align-middle border border-gray-400" }, " Designation "),
                  /*#__PURE__*/_createElementVNode("th", { class: "w-50px text-center align-middle border border-gray-400" }, " Salary "),
                  /*#__PURE__*/_createElementVNode("th", { class: "w-50px text-center align-middle border border-gray-400" }, " Joining Date "),
                  /*#__PURE__*/_createElementVNode("th", { class: "w-50px text-center align-middle border border-gray-400" }, " Release Date "),
                  /*#__PURE__*/_createElementVNode("th", { class: "w-50px text-center align-middle border border-gray-400" }, " Duration (Months) ")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("tbody", null, [
                /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400 text-center" }, [
                  /*#__PURE__*/_createElementVNode("td", null, "1"),
                  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " M/S Hoq Engineering Works "),
                  /*#__PURE__*/_createElementVNode("td", { class: "text-dark fw-bolder text-hover-primary fs-6" }, " Welder "),
                  /*#__PURE__*/_createElementVNode("td", null, "7000"),
                  /*#__PURE__*/_createElementVNode("td", null, "05-11-2016"),
                  /*#__PURE__*/_createElementVNode("td", null, "Till Date"),
                  /*#__PURE__*/_createElementVNode("td", null, "63.57")
                ]),
                /*#__PURE__*/_createElementVNode("tr", { class: "border border-gray-400" }, [
                  /*#__PURE__*/_createElementVNode("td", {
                    class: "text-end font-weight-bold fw-bolder",
                    colspan: "6"
                  }, " Total "),
                  /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "63.57")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-6 p-4" }, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary"
}, "Update", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Tranche-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(),
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Association",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.entity_short_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Institutes",
                      modelValue: _ctx.batch.training_institute,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.training_institute) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Augmedix Bangladesh",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Augmedix Bangladesh")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Genex Infosys Limited",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Genex Infosys Limited")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Mars Solutions Limited",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mars Solutions Limited")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Noble It Solution Ltd",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Noble It Solution Ltd")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Digicon Technologies Ltd.",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Digicon Technologies Ltd.")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Service Solutions Pvt. Ltd.",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Service Solutions Pvt. Ltd.")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course",
                      modelValue: _ctx.batch.course,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "BACCO-MS | Medical Scribing | 2 | 160 | 31519",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("BACCO-MS | Medical Scribing | 2 | 160 | 31519")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.batch,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.batch) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseNotice()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Trainee",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Trainess",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("132166313")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Trainess",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("132166313")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Trainess",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("132166313")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Trainess",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("132166313")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Trainess",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("132166313")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Trainess",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("132166313")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Trainess",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("132166313")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                (_ctx.showCourseNotice == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                  : _createCommentVNode("", true),
                (_ctx.showCourseNotice == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_component_Datatable, {
                                  "table-data": _ctx.tableData,
                                  "table-header": _ctx.tableHeader,
                                  "enable-items-per-page-dropdown": true
                                }, {
                                  "cell-id": _withCtx(({ row }) => [
                                    _createTextVNode(_toDisplayString(row.id), 1)
                                  ]),
                                  "cell-image": _withCtx(({ row }) => [
                                    _createTextVNode(_toDisplayString(row.image), 1)
                                  ]),
                                  "cell-name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry.name), 1)
                                  ]),
                                  "cell-father_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry.father_name), 1)
                                  ]),
                                  "cell-mother_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry.mother_name), 1)
                                  ]),
                                  "cell-nid": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry.nid), 1)
                                  ]),
                                  "cell-phone": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry.phone), 1)
                                  ]),
                                  "cell-dob": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry.dob), 1)
                                  ]),
                                  _: 1
                                }, 8, ["table-data", "table-header"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_Form, {
                              onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formSubmit())),
                              class: "form",
                              "validation-schema": _ctx.AssociationSchema
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _hoisted_42,
                                    _createVNode(_component_el_form_item, {
                                      prop: "date",
                                      class: "mb-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.employee.registration_date,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.employee.registration_date) = $event)),
                                          "value-format": "YYYY-MM-DD",
                                          format: "DD-MM-YYYY",
                                          type: "date",
                                          style: {"width":"100%"}
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _hoisted_43,
                                  _hoisted_44
                                ])
                              ]),
                              _: 1
                            }, 8, ["validation-schema"])
                          ])
                        ])
                      ]),
                      _hoisted_45,
                      _hoisted_46,
                      _hoisted_47,
                      _hoisted_48,
                      _hoisted_49,
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_Form, {
                              onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.formSubmit())),
                              class: "form",
                              "validation-schema": _ctx.AssociationSchema
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_53, [
                                  _hoisted_54,
                                  _createElementVNode("div", _hoisted_55, [
                                    _hoisted_56,
                                    _hoisted_57,
                                    _createVNode(_component_el_form_item, { prop: "end_date" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.batch.end_date,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.batch.end_date) = $event)),
                                          "value-format": "YYYY-MM-DD",
                                          format: "DD-MM-YYYY",
                                          style: {"width":"100%"},
                                          type: "date",
                                          name: "end_date"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _hoisted_58
                                ]),
                                _hoisted_59
                              ]),
                              _: 1
                            }, 8, ["validation-schema"])
                          ])
                        ])
                      ]),
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62,
                      _hoisted_63
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}